import { Component, OnInit } from '@angular/core';
import { EntryService } from '../entry.service';
import { Entry } from '../entry';

@Component({
  selector: 'app-rejected',
  templateUrl: './rejected.component.html',
  styleUrls: ['./rejected.component.less']
})
export class RejectedComponent implements OnInit {
  entries: Entry[];

  constructor(private entryService: EntryService) { }

  ngOnInit(): void {
    this.entries = this.entryService.entries;
    }

    selectEntry(submissionID: string, event: any): void {
      const entryIndex = this.entries.findIndex(i => i.submissionID === submissionID);

      console.log(event);
      console.log('Handling ' + submissionID + ', index=' + entryIndex);
      this.entryService.rateEntry(entryIndex, event);
    }
}
